export default {
	data() {
		return {
			commandToReplay: null,
		};
	},
	methods: {
		replayCommand(command) {
			this.commandToReplay = command;

			this.$nextTick(() => {
				this.commandToReplay = null;
			});
		},
	},
}
